import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { constants } from '../../constants/constants';

@Injectable({
	providedIn: 'root'
})
export class ClientService {
	isClientFeatureEnabled(featureCode: string): boolean {
		return !!LocalStorageService.getItem(
			constants.localStorageKeys.CLIENT_DETAILS
		)?.clientFeaturesReferences.find(
			(featureReference) => featureReference.clientFeatureId === featureCode
		);
	}
}
